import React, { useEffect, useState } from 'react';

import Introduction from '../sections/Home/Introduction';
import Experience from '../sections/Home/Experience';
import Featured from '../sections/Home/Featured';
import Footer from '../components/Footer';
import { buildApiUrl } from '../utils/api';
import { homeContent } from '../constants/homeContent';

import '../static/styles/Home.css';

export default function Home() {
    const [featuredProjects, setFeaturedProjects] = useState([]);
    const [isFeaturedLoading, setIsFeaturedLoading] = useState(true);
    const [featuredError, setFeaturedError] = useState(null);
    const resumeUrl = /^https?:\/\//i.test(homeContent.resume)
        ? homeContent.resume
        : buildApiUrl(homeContent.resume);

    useEffect(() => {
        const controller = new AbortController();
        const homeEndpoint = buildApiUrl('/home');

        fetch(homeEndpoint, { signal: controller.signal })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Failed to fetch home content: ${response.status}`);
                }

                return response.json();
            })
            .then((payload) => {
                setFeaturedProjects(payload.featured_projects ?? []);
                setFeaturedError(null);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    setFeaturedError('Unable to load featured projects right now.');
                    console.error('Error fetching featured projects:', error);
                }
            })
            .finally(() => {
                if (!controller.signal.aborted) {
                    setIsFeaturedLoading(false);
                }
            });

        return () => controller.abort();
    }, []);

    return (
        <>
            <Introduction resume={resumeUrl} />
            <Experience data={homeContent.experience} />
            <Featured data={featuredProjects} isLoading={isFeaturedLoading} error={featuredError} />
            <Footer />
        </>
    );
}
